import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3206, { U3206ROLES } from './U3206';
import U3206AiUserGroupList from './components/U3206AiUserGroupList';
import U3206AiUserGroupForm from './components/U3206AiUserGroupForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3206Routes: RouteObject[] = [
  {
    path: 'U3206',
    element: <U2000RequireRole allowedRoles={[U3206ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3206 />,
        children: [
          { index: true, element: <U3206AiUserGroupList /> },
          { path: ':id', element: <U3206AiUserGroupForm /> },
        ],
      },
    ],
  },
];

export default U3206Routes;
